import { FunctionComponent, ReactElement } from "react";
import useRouterContext from "../hooks/useRouterContext";
import { pathMatch } from "../utils";
import NoRouteMatch, { Props as NoRouteMatchProps } from "./NoRouteMatch";
import Route, { Props as RouteProps } from "./Route";

interface Props {
  children: Array<ReactElement<RouteProps> | ReactElement<NoRouteMatchProps>>;
}

const RouteSwitch: FunctionComponent<Props> = ({ children }) => {
  const context = useRouterContext();

  const routeComponents = children.filter((child: ReactElement) => child.type === Route) as Array<
    ReactElement<RouteProps>
  >;

  const firstMatchedRouteComponent = routeComponents.find((child) => {
    const {
      props: { path, exact = true },
    } = child;
    const locationHash = context.history.location.hash;

    if (locationHash && pathMatch(path, `${context.path}${locationHash}`, exact)) {
      return true;
    }
    return pathMatch(path, context.path, exact);
  });

  if (firstMatchedRouteComponent) {
    return firstMatchedRouteComponent;
  }

  const noRouteMatchComponent = children.find(
    (child: ReactElement) => child.type === NoRouteMatch
  ) as ReactElement<NoRouteMatchProps> | null;

  if (noRouteMatchComponent) {
    return noRouteMatchComponent;
  }

  return null;
};

export default RouteSwitch;
